import { useTranslation } from 'react-i18next';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';

import 'app/components/editor/sidebar/tags/Modal/Modal.scss';

interface DeleteBlockModalProps {
  show: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteBlockModal = ({ show, message, onConfirm, onCancel }: DeleteBlockModalProps) => {
  const { t } = useTranslation('block');

  return (
    <BootstrapModal show={show} onHide={onCancel} contentClassName="tags-modal__content tags-modal__content--continuation" centered>
      <button onClick={onCancel} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-trash tags-modal__tag-icon tags-modal__tag-icon--danger" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {t('delete.modal.title')}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {message}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onCancel}>
          {t('delete.modal.cancel')}
        </button>
        <button className="tags-modal__btn-confirm tags-modal__btn-confirm--danger" onClick={onConfirm}>
          {t('delete.modal.confirm')}
        </button>
      </div>
    </BootstrapModal>
  );
};
